var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48358(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.886,
    height: 71.79,
    viewBox: "0 0 76.886 71.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48358",
    "data-name": "Group 48358",
    transform: "translate(-922.495 -1420.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39145",
    "data-name": "Path 39145",
    d: "M56.308,25.5H29.385A5.39,5.39,0,0,0,24,30.885V47.038a5.39,5.39,0,0,0,5.385,5.385H40.154V47.038H29.385V30.885H56.308V47.038H49.483L42.5,57.512l4.48,2.988,5.385-8.077h3.944a5.39,5.39,0,0,0,5.385-5.385V30.885A5.39,5.39,0,0,0,56.308,25.5Z",
    transform: "translate(936.938 1430.5)",
    fill: "#0267c1",
    stroke: "#e7eff9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39146",
    "data-name": "Path 39146",
    d: "M20.949,44.64l2.318-2.321a2.243,2.243,0,0,1,2.42-.5l2.827,1.131a2.243,2.243,0,0,1,1.408,2.081v5.137a2.243,2.243,0,0,1-2.367,2.245c-19.8-1.23-23.8-18-24.54-24.425A2.24,2.24,0,0,1,5.245,25.5H10.29a2.245,2.245,0,0,1,2.084,1.411L13.5,29.738a2.243,2.243,0,0,1-.5,2.418l-2.321,2.318A12.188,12.188,0,0,0,20.946,44.64Z",
    transform: "translate(920.247 1430.5)",
    fill: "#0267c1",
    stroke: "#e7eff9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39147",
    "data-name": "Path 39147",
    d: "M31.5,13.5H50.346v5.385H31.5Z",
    transform: "translate(942.9 1420.962)",
    fill: "#0267c1",
    stroke: "#e7eff9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39148",
    "data-name": "Path 39148",
    d: "M31.5,7.5H55.731v5.385H31.5Z",
    transform: "translate(942.9 1416.192)",
    fill: "#0267c1",
    stroke: "#e7eff9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39149",
    "data-name": "Path 39149",
    d: "M43.385,11.385l-8.077,5.923V11.385A5.39,5.39,0,0,0,29.923,6H8.385A5.39,5.39,0,0,0,3,11.385V27.538a5.39,5.39,0,0,0,5.385,5.385H29.923a5.39,5.39,0,0,0,5.385-5.385V21.615l8.077,5.923Zm-35,16.154V11.385H29.923V27.538Z",
    transform: "translate(920.246 1415)",
    fill: "#0267c1",
    stroke: "#e7eff9",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48358);
export default __webpack_public_path__ + "static/media/Group 48358.ad89852b666b95c00c1de0ba2eb58236.svg";
export { ForwardRef as ReactComponent };